import type { FaireProductEntity } from "../../entity_types/product";

export const p_s2pkt7wr45: FaireProductEntity = {
  token: "p_s2pkt7wr45",
  type: "product",
  name: "Strawberry Matcha Latte Depuffing & Hydrating Eye Patches Filled PDQ Display (10 pcs)",
  brandToken: "b_8oy7a20lz0",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/ec853ae14fe676c925619787dd7b26fbc36ae8b47dee5550ad7c4cfed67fadeb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/074da4a90ca75f3f744a4ea85914821ab706a0fd2727860f104c1001e26033ac.jpeg",
  ],
  priceDollars: 25,
  description:
    "Shop our new custom PDQ displays - the perfect way to showcase our Latte Eye Patches in your store! This display contains 10 units prepackaged inside. **ESW Beauty Latte Eye Patches are included and do not need to be purchased separately. \n\nHow to Use: \n(1) Carefully remove the top of the display (following the tear lines) \n(2) Place your filled display of 10 ESW Beauty Latte Eye Patches in the perfect spot at your store!\n\n🫧 Clean Ingredients\n🌱 Vegan\n🫶 Cruelty-Free\n♻️ Sustainable\n🌎 Made in Korea (K-Beauty Inspired)\n\nIdeal for self-care, impulse buys, gifting, back-to-school, holidays, spas, boutiques, and combatting Fall/Winter dry skin",
  tags: [],
  msrpDollars: 49.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:38.260Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
